import { type MainStoreState } from '@common/store/reducers';
import { type FeatureFlagsStoreState } from '@common/store/reducers/featureFlags';
import { type GraphsStoreState } from '@common/store/reducers/graphs';

export enum UserState {
  Unknown = -1,
  LoggedOut = 0,
  LoggedIn = 1,
}

export type PageLayout = 'regular' | 'windowed';

export type DeviceRegistrationFlowType = 'device' | 'isg';

export interface StoreState {
  main: MainStoreState;
  featureFlags: FeatureFlagsStoreState;
  graphs: GraphsStoreState;
}
